export const ColProps_1 = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 12,
  xl: 12,
};
export const ColProps_2 = {
  xs: 6,
  sm: 6,
  md: 6,
  lg: 6,
  xl: 6,
};
export const ColProps_3 = {
  xs: 4,
  sm: 4,
  md: 4,
  lg: 4,
  xl: 4,
};
export const ColProps_4 = {
  xs: 3,
  sm: 3,
  md: 3,
  lg: 3,
  xl: 3,
};
export const ColProps_5 = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 6,
  xl: 6,
};

export const ColProps_6 = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 7,
  xl: 7,
};

export const ColProps_7 = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 5,
  xl: 5,
};

export const ColProps_8 = {
  xs: 12,
  sm: 12,
  md: 8,
  lg: 8,
  xl: 8,
};
export const ColProps_9 = {
  xs: 12,
  sm: 12,
  md: 4,
  lg: 4,
  xl: 4,
};

export const ColProps_10 = {
  xs: 2,
  sm: 2,
  md: 2,
  lg: 2,
  xl: 2,
};

export const ColProps_11 = {
  xs: 1,
  sm: 1,
  md: 1,
  lg: 1,
  xl: 1,
};

export const ColProps_12 = {
  xs: 11,
  sm: 11,
  md: 11,
  lg: 11,
  xl: 11,
};

export const ColProps_13 = {
  xs: 12,
  sm: 12,
  md: 3,
  lg: 3,
  xl: 3,
};

export const ColProps_14 = {
  xs: 6,
  sm: 6,
  md: 4,
  lg: 4,
  xl: 4,
};
